import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram, FaFacebook, FaLinkedin } from "react-icons/fa";

export const footerSections = [
  {
    title: "Corporate Info",
    links: [
      { label: "Company Overview", href: "/about-us" },
      { label: "Case Studies", href: "/success-stories" },
      { label: "Careers", href: "/career" },
      { label: "Life @ Tycho", href: "/life-at-tycho" },
      { label: "Privacy Policy", href: "/privacy-policy" },
      { label: "Terms & Conditions", href: "/terms-conditions" },
      { label: "Return & Refund Policy", href: "/refund-policy" },
    ],
  },
  {
    title: "Services Offerings",
    links: [
      { label: "Mobile App Development", href: "/mobile-app-development-services-india" },
      { label: "Website Development", href: "/web-app-development-services-india" },
      { label: "Frontend Services", href: "/frontend-app-development-services-india" },
      { label: "Backend Services", href: "/backend-app-development-services-india" },
      { label: "T.V App Development", href: "/ott-platform-development-services-india" },
      { label: "SEO And Lead Generation", href: "/digital-marketing-services-india" },
      { label: "SEO Company", href: "/seo-content-strategy-services-india" },
    ],
  },
  {
    title: "Tech.CoE",
    links: [
      { label: "AI ML", href: "/ai-ml-development-services-india" },
      { label: "DevOps", href: "/devops-cloud-development-services-india" },
      { label: "Blockchain", href: "/blockchain-development-services-india" },
      { label: "Flutter", href: "/flutter-app-development-services-india" },
      { label: "Android", href: "/android-app-development-services-india" },
      { label: "OTT Platform", href: "/ott-platform-development-services-india" },
    ],
  },
];

export const socialLinks = [
  { icon: <FaFacebook aria-hidden="true" />, label: "Facebook", href: "https://www.facebook.com/tychotechnologiespvtltd/" },
  { icon: <FaXTwitter aria-hidden="true" />, label: "Twitter", href: "https://x.com/TychoTech" },
  {
    icon: <FaLinkedin aria-hidden="true" />,
    label: "LinkedIn",
    href: "https://in.linkedin.com/company/tycho-technologies-pvt-ltd?original_referer=https%3A%2F%2Fwww.tychotechnologies.com%2F",
  },
  { icon: <FaInstagram aria-hidden="true" />, label: "Instagram", href: "https://www.instagram.com/urtechpartners" },
];
